import {PlatformNavbar, PlatformNavbarMode} from '@flexinet/ui-components';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {getMenuItems} from '../data/menus';
import product from '../../../config/product';

// Sidebar nav for the authenticated shell. Reads getMenuItems() and
// filters by Verified Permissions allowedActions so RBAC-denied items
// disappear automatically.
//
// `appTitle` is the application's own name, read from config/product.ts and
// never typed here (FNP-1367).
export const PortalNavbar = ({
    mode,
    changeMode,
}: {
    mode: PlatformNavbarMode;
    changeMode: (mode: PlatformNavbarMode) => void;
}) => {
    const {allowedActions} = useVerifiedPermissions();
    const items = getMenuItems();
    const menuItems = items.filter((item) => allowedActions.includes(item.rbac as string));

    return (
        <PlatformNavbar
            appTitle={product.displayName}
            menuItems={menuItems}
            mode={mode}
            changeMode={changeMode}
        />
    );
};
